import getColor from "@insite/mobius/utilities/getColor";
import { siteWidthStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        typographyProps: {
            color: "text.accent",
        },
        css: css`
            padding-top: 1.5em;
            flex-wrap: wrap;
            color: ${getColor("text.accent")};
            ${siteWidthStyles()}

            a:hover {
                color: ${getColor("text.accent")};
            }

            > span:last-child {
                font-weight: ${TYPOGRAPHY.weight.bold};
                color: ${getColor("primary.dark")};
            }
        `,
    },
};
